import { Navigate } from "react-router-dom";
import { useAppSelector } from "../hooks/useAppSelector";
import { canScanQr, isAdmin } from "../helpers/roles";

/**
 * Admin route guard (ADMIN + SUPERADMIN). Missing/empty rol defaults to ADMIN.
 * Aligned with CustomClaimsPrincipalExtensions.IsAdmin().
 * Unknown/typo roles → /404 (no AdminRoute ↔ QrScannerRoute loop).
 */
function AdminRoute({ children }) {
  const user = useAppSelector((state) => state.auth.user);
  const rol = user?.rol;

  if (isAdmin(rol)) {
    return children;
  }

  if (canScanQr(rol)) {
    return <Navigate to="/qr-scanner" replace />;
  }

  return <Navigate to="/404" replace />;
}

export { AdminRoute };
